import deprecate from './utils/deprecate';
import { MOBILE_V1 } from './utils/endpoints';

/* eslint-disable id-length */

export default ((_ref, updateContext, getContext) => {
  var shared = _ref.shared,
    _ref$endpoints = _ref.endpoints,
    endpoints = _ref$endpoints === void 0 ? {} : _ref$endpoints;
  var apiClient = shared.apiClient,
    getAbsoluteUrl = shared.getAbsoluteUrl;
  var _endpoints$inspection = endpoints.inspectionPlanEndpoint,
    inspectionPlanEndpoint = _endpoints$inspection === void 0 ? "".concat(MOBILE_V1, "/inspection") : _endpoints$inspection;
  var endpoint = action => "".concat(getAbsoluteUrl(inspectionPlanEndpoint), "/").concat(action);
  var postWithToken = apiClient.postWithToken;
  var ADD = endpoint('add');
  var REMOVE = endpoint('remove');
  var FETCH = endpoint('fetch');
  var updateInspections = inspections => updateContext({
    inspections,
    events: inspections // for compatibilty, remove when removing deprecated methods
  });
  var addInspectionToPlan = (listingId, startTime) => postWithToken(ADD, {
    listingId,
    startTime
  }).then(_ref2 => {
    var inspections = _ref2.inspections;
    // successfully added, update the context for observers
    updateInspections(inspections);
    return inspections;
  });
  var removeInspectionFromPlan = (listingId, startTime) => postWithToken(REMOVE, {
    listingId,
    startTime
  }).then(_ref3 => {
    var inspections = _ref3.inspections;
    // successfully removed, update the context for observers
    updateInspections(inspections);
    return inspections;
  });
  var isInInspectionPlan = _ref4 => {
    var listingId = _ref4.listingId,
      startTime = _ref4.startTime;
    if (!listingId && !startTime) {
      return false;
    }
    var context = getContext();
    return context && context.inspections && context.inspections.some(inspection => listingId && inspection.listingId === listingId && (startTime ? inspection.startTime === startTime : true));
  };
  var fetchInspectionPlan = () => postWithToken(FETCH);
  var inspectionApi = {
    events: [],
    // Deprecated
    inspections: [],
    addInspectionToPlan,
    addEventToPlan: deprecate.function(addInspectionToPlan, 'Use addInspectionToPlan instead'),
    removeInspectionFromPlan,
    removeEventFromPlan: deprecate.function(removeInspectionFromPlan, 'Use removeInspectionFromPlan instead'),
    isInInspectionPlan,
    fetchInspectionPlan
  };
  return inspectionApi;
});